module.exports = __webpack_public_path__ + "static/media/mc.8fb7d82c.svg";